import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import "./prism-v2/prism-v2.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
